import React, { useEffect, useState } from "react";
import "./wallet.css";
import { Axios } from "../../../Axios";
import { BASE_URL } from "../../../Axios/base_url";
import { ThreeCircles, ThreeDots } from "react-loader-spinner";
import UseGeneral from "../../../hooks/useGeneral";
import ContentLoader from "react-content-loader";
import axios from "axios";
import PopUp from "../../../components/popup";
import toast from "react-hot-toast";
const Wallet = () => {
  const { language } = UseGeneral();
  let greenLocalData = localStorage.getItem("greenTreesUserData");
  let greenData = greenLocalData && JSON.parse(greenLocalData);
  // const [pageLoading,setPageLoading]=useState(false)
  const [wallets, setWallets] = useState([]);
  const [showAddModel, setShowAddModel] = useState(false);
  const data = [
    {
      number: "RTV2243A",
      date: "10/01/2024",
      totalPrice: "40.00",
    },
    {
      number: "RTV2243A",
      date: "10/01/2024",
      totalPrice: "40.00",
    },
    {
      number: "RTV2243A",
      date: "10/01/2024",
      totalPrice: "40.00",
    },
  ];
  const [newWal, setNewWal] = useState({
    phone: "",
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [rowData, setRowData] = useState({});
  const [addLoading, setAddLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const getMyWallets = () => {
    setPageLoading(true);
    axios
      .get(
        BASE_URL + `user_wallets/get_users_wallet/${greenData && greenData?.id}`
      )
      .then((res) => {
        ;
        if (res.data.status == "success") {
          if (Array.isArray(res.data.result)) {
            setWallets(res.data.result);
          }
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setPageLoading(false);
      });
  };
  const [phoneWallet, setPhoneWallet] = useState(null);
  const handleAdd = () => {
    if (newWal.phone == "") {
      toast.error(
        language == "ar" ? "إكتب رقم المحفظه " : "Write Wallet Number"
      );
    }
    setAddLoading(true);
    const data_send = {
      ...newWal,
    };
    axios
      .post(
        BASE_URL + `user_wallets/add_new/${greenData && greenData?.id}`,
        data_send,
        {
          headers: {
            lang: language,
          },
        }
      )
      .then((res) => {
        ;
        if (res.data.status == "success") {
          toast.success(res.data.message);
          setShowAddModel(false);
          setPhoneWallet(null);
          getMyWallets();
        } else if (res.data.status == "faild") {
          toast.error(res.data.message);
        } else {
          toast.error(language == "ar" ? "حدث خطأ ما" : "Something Went Error");
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setAddLoading(false);
      });
  };
  const handleEdit = (add) => {
    if (rowData.phone == "") {
      toast.error(
        language == "ar" ? "إكتب رقم المحفظه " : "Write Wallet Number"
      );
    }
    setAddLoading(true);
    const data_send = {
      ...rowData,
    };
    ;
    axios
      .post(
        BASE_URL + `user_wallets/edit_one/${greenData && greenData?.id}`,
        data_send,
        {
          headers: {
            lang: language,
          },
        }
      )
      .then((res) => {
        if (res.data.status == "success") {
          toast.success(res.data.message);
          setShowEditModal(false);
          getMyWallets();
        } else if (res.data.status == "faild") {
          toast.error(res.data.message);
        } else {
          toast.error(language == "ar" ? "حدث خطأ ما" : "Something Went Error");
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setAddLoading(false);
      });
  };
  useEffect(() => {
    getMyWallets();
  }, []);
  return (
    <div className="wallet-container">
      <div className="top-title">
        <h4 className="title">
          {/* {language == "ar" ? "الرصيد الكلي" : "Total balance"} */}
        </h4>
        {/* <h2>10.00 {language == 'ar' ? 'د.إ' : 'AED'}</h2> */}
      </div>
      <div className="cards my-6">
        {pageLoading ? (
          <ThreeDots />
        ) : (
          <>
            {/* <div className="my-6">
              {wallets && wallets.length == 0 && (
                <h5
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowAddModel(true);
                  }}
                  className="text-success"
                >
                  {language == "ar" ? "إضافه محفظه" : "Add Wallet"}
                </h5>
              )}
            </div> */}
            {wallets && wallets.length == 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "40vh",
                }}
              >
                <h5>
                  {language == "ar"
                    ? "لا يوجد محافظ"
                    : "There Are Not Any Wallets"}
                </h5>
              </div>
            )}
            {wallets && wallets.length > 0 && (
              <h5>
                {language == "ar" ? "المحفظه المتاحه" : "Available wallet"}
              </h5>
            )}
            {
              wallets &&
                wallets.map((item, index) => {
                  return (
                    <div className="wallet_one">
                      <h5 className="d-flex ga-2">
                        <span>
                          {language == "ar" ? "رقم المحفظه:" : "Wallet Number:"}
                        </span>
                        <span>{item.phone}</span>
                      </h5>
                      <h5 className="d-flex ga-2">
                        <span>
                          {language == "ar" ? "الرصيد  :" : "Balance :"}
                        </span>
                        <span>
                          {item.balance} {language == "ar" ? "د.إ" : "AED"}
                        </span>
                      </h5>
                      {/* <div className="my-3">
                        <button
                          onClick={() => {
                            setShowEditModal(true);
                            setRowData(item);
                          }}
                          className="btn btn-success"
                        >
                          {language == "ar" ? "تعديل" : "Edit"}
                        </button>
                      </div> */}
                    </div>
                  );
                })
              // data?.map((item) => (
              //   <div className="item-card">
              //     <div>
              //       {" "}
              //       {language == "ar" ? "رقم الطلب" : "Order number"} {item?.number}
              //     </div>
              //     <div className="center">
              //       <span>{item.date}</span>
              //       <div className="price">
              //         {item.totalPrice} {language == 'ar' ? 'د.إ' : 'AED'}
              //       </div>{" "}
              //     </div>
              //     <div className="return-button">
              //       {language == "ar" ? "استرداد" : "Refund"}
              //     </div>
              //   </div>
              // ))
            }
          </>
        )}
      </div>

      <PopUp
        open={showAddModel}
        title={language == "ar" ? "إضافة محفظه" : "Add Wallet"}
        setOpen={() => {
          setShowAddModel(false);
        }}
        children={
          <>
            <form onSubmit={(e) => e.preventDefault()} className="new_wall">
              <div className="form_input mb-2">
                <label htmlFor="">
                  {language == "ar" ? "رقم المحفظه" : "Wallet Number"}
                </label>
                <input
                  onChange={(e) => {
                    setRowData({ ...rowData, phone: e.target.value });
                  }}
                  type="text"
                  placeholder={language == "ar" ? "رقم الهاتف" : "Phone Number"}
                />
              </div>
              <button
                className="btn btn-success"
                disabled={addLoading}
                onClick={() => {
                  handleEdit();
                }}
              >
                {language == "ar" ? "إضافه" : "Add"}
              </button>
            </form>
          </>
        }
      />
      <PopUp
        open={showEditModal}
        title={language == "ar" ? "تعديل محفظه" : "Edit Wallet"}
        setOpen={() => {
          setShowEditModal(false);
        }}
        children={
          <>
            <form onSubmit={(e) => e.preventDefault()} className="new_wall">
              <div className="form_input mb-2">
                <label htmlFor="">
                  {language == "ar" ? "رقم المحفظه" : "Wallet Number"}
                </label>
                <input
                  value={rowData?.phone}
                  onChange={(e) => {
                    setRowData({ ...rowData, phone: e.target.value });
                  }}
                  type="text"
                  placeholder={language == "ar" ? "رقم الهاتف" : "Phone Number"}
                />
              </div>
              <button
                className="btn btn-success"
                disabled={addLoading}
                onClick={() => {
                  handleEdit();
                }}
              >
                {language == "ar" ? "تعديل" : "Edit"}
              </button>
            </form>
          </>
        }
      />
    </div>
  );
};

export default Wallet;
